import { FC } from 'react'
import classnames from 'classnames'
import { Answer } from 'mytours-read-api-typescript'
import { ImageSizePreset } from '../../../common_lib/types'
import { generateImageUrl } from '../../../common_lib/utils'
import '../styles/imageChoiceAnswer.less'

interface ImageChoiceAnswerProps {
	answer: Answer
	onClick?: () => void
	isAnswered?: boolean
	isChecked?: boolean
	hasAttempts: boolean
}

const ImageChoiceAnswer: FC<ImageChoiceAnswerProps> = ({ answer, onClick, isChecked, isAnswered, hasAttempts }) => {
	const answerCorrect = isAnswered && answer?.correct
	const answeredIncorrect = isAnswered && isChecked && !answer?.correct

	const imageUrl = answer?.answer_media_item?.file && generateImageUrl(answer.answer_media_item.file, { imageSizePreset: ImageSizePreset.Row })

	return (
		<div
			className={classnames('image-choice-answer', {
				'-checked': isChecked,
				'-correct': (answerCorrect && !hasAttempts) || (hasAttempts && isChecked && answerCorrect),
				'-incorrect': answeredIncorrect,
				'-answered': isAnswered,
			})}
			onClick={!isAnswered ? onClick : null}
		>
			<div className="icon-wrapper ion-justify-content-center ion-align-items-center">
				<i
					className={classnames({
						'far fa-circle-xmark': answeredIncorrect,
						'fas fa-check': (isChecked && !isAnswered) || (answerCorrect && !isChecked && !hasAttempts),
						'far fa-circle-check': answerCorrect && isChecked,
					})}
				/>
			</div>
			<div className="bg-image" style={{ backgroundImage: `url(${imageUrl})` }} />
		</div>
	)
}

export default ImageChoiceAnswer
